export function upsertMetaTag(selector: string, attrs: Record<string, string>) {
  const head = document.head
  const existing = head.querySelector<HTMLMetaElement>(selector)
  const el = existing ?? document.createElement('meta')
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v))
  if (!existing) head.appendChild(el)
  return el
}

export function upsertLinkTag(selector: string, attrs: Record<string, string>) {
  const head = document.head
  const existing = head.querySelector<HTMLLinkElement>(selector)
  const el = existing ?? document.createElement('link')
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v))
  if (!existing) head.appendChild(el)
  return el
}

export function upsertJsonLd(id: string, data: unknown) {
  const head = document.head
  const selector = `script#${CSS.escape(id)}`
  const existing = head.querySelector<HTMLScriptElement>(selector)
  const el = existing ?? document.createElement('script')
  el.id = id
  el.type = 'application/ld+json'
  el.text = JSON.stringify(data)
  if (!existing) head.appendChild(el)
  return el
}
